module.exports = __webpack_public_path__ + "img/calendar-gamma.27e0a93c.svg";